import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StickyHeader } from '@components/molecules/StickyHeader/StickyHeader';
import { BreadcrumbsBanner } from '@components/molecules/BreadcrumbsBanner';
import { CenteredText } from '@components/molecules/CenteredText';
import { PromoBasketsList } from '@components/molecules/PromoBasketsList';
import { PromoBasketCardProps } from '@components/molecules/PromoBasketCard';
import { Space } from '@components/atoms/Space';
import { MenuPages } from '@types';
import { Footer } from '@components/molecules/Footer';
import { MarketplaceAdvertising } from '@components/molecules/MarketplaceAdvertising';
import { Container } from '@components/atoms/Container';
import { useData } from '@hooks/useData';

export interface PromoBasketsProps {
    promoBasketsHighlights: PromoBasketCardProps[];
}

export const Baskets: FC<PromoBasketsProps> = ({ promoBasketsHighlights }) => {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('baskets-component.title'),
        promoBasketsHighlightsTitle: t('campaigns-component.promo-baskets-highlights.title'),
        centeredTextPreTitle: t('centered-text-component.pre-title'),
        centeredTextTitle: t('centered-text-component.title'),
        centeredTextParagraphOne: t('centered-text-component.paragraph-one'),
        centeredTextParagraphTwo: t('centered-text-component.paragraph-two')
    };

    return (
        <>
            <StickyHeader menuActivePage={MenuPages.PromoBaskets} />

            <BreadcrumbsBanner
                title={translations.title}
                links={[]}
                currentPage={translations.title}
                image={allSettings?.data?.content_headers_products_bundles_image}
            />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <Container customSize="custom-small">
                <CenteredText preTitle={translations.centeredTextPreTitle} title={translations.centeredTextTitle} paragraphOne={translations.centeredTextParagraphOne} paragraphTwo={translations.centeredTextParagraphTwo} />
            </Container>

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <PromoBasketsList
                title={translations.promoBasketsHighlightsTitle}
                promoBaskets={promoBasketsHighlights}
                titleAlign="center"
            />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <MarketplaceAdvertising />

            <Footer mode="normal" />
        </>
    );
};
